<template>
    <div style="height: 100%;">
        <el-form :inline="true"  :model="param" class="demo-form-inline">
            <el-form-item label="卡号">
                <el-input v-model="param.cardnumber" size="mini" style="width: 80px;" @change="changeQuery"></el-input>
            </el-form-item>
            <el-form-item label="日期">
                <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100px"
                                        v-model="param.accountdate" name="birthday"
                                        type="date"
                                        placeholder="选择日期" @change="changeQuery">
                        </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="openBuyCardCourse">买疗程</el-button>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 2rem)"  border :data="queryCardOperation" class="myform" size="mini" style="text-align: center" :show-header="false" highlight-current-row v-loadmore="getCardOperationByParam">
            <el-table-column label="合作门店" align="center"prop="hzstorename">
                <template slot-scope="scope">
                    <el-form label-position="left" size="mini">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="合作门店">
                                   {{scope.row.cardOperation.hzstorename}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="日期">
                                    {{$moment(scope.row.cardOperation.accountdate).format('YYYY-MM-DD')}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="卡号">
                                    {{scope.row.cardOperation.cardnumber}}
                                </el-form-item>
                                
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="姓名">
                                    {{scope.row.cardOperation.membername}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-for="(item,index) in scope.row.buyCourses" :key="index">
                            <el-col :span="12">
                                <el-form-item label="课程名">
                                    {{item.projectname}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item>
                                    {{item.number}}次({{item.amount}}元)
                                </el-form-item>
                            </el-col>

                            
                        </el-row>
                    </el-form>
                </template>
            </el-table-column>
        </el-table>
    
    <el-dialog title="购买疗程" :visible.sync="dialogVisible" width="100%" top="0px" :lock-scroll="false" :fullscreen="true" :before-close="handleClose">
        <el-form ref="form" :model="addCardOperation" label-width="80px" size="mini" :rules="rules">
            <el-form-item label="会员卡号" prop="cardnumber"> 
                <el-input v-model="addCardOperation.cardnumber" size="mini" @change="getCardInfoByCourse"></el-input>
            </el-form-item>
            <el-form-item label="会员姓名" prop="membername">
                <el-input v-model="addCardOperation.membername" size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="memberphone">
                <el-input v-model="addCardOperation.memberphone" size="mini" disabled></el-input>
            </el-form-item>
        </el-form>
        <el-form size="mini" class="myform">
            <div v-for="(item,index) in addBuyCourse" :key="index" style="border-bottom: 1px solid #DCDFE6;padding-bottom: 10px;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="疗程名称"> 
                            <el-select v-model="item.projectid" placeholder="请选择" style="width: 100%;" @change="changeProject(item)" size="mini" clearable>
                                <el-option v-for="item in projectInfos" :key="item.projectid" :label="item.projectname" :value="item.projectid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="数量">
                            <el-input v-model="item.number" size="mini" type="number" @change="numberChange(item)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="金额">
                            <el-input v-model="item.amount" size="mini" type="number" @change="amountChange(item)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="销售人员">
                            <el-select v-model="item.staffid1" placeholder="请选择" style="width: 100%;" @change="staffchange(item)" size="mini">
                                <el-option v-for="item in staffInfos" :key="item.staffid" :label="item.staffname" :value="item.staffid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose" size="mini">取 消</el-button>
            <el-button type="primary" size="mini" :loading="queryLoadBtton" @click="saveBuyCourse">保存</el-button>
        </div>
    </el-dialog>
    <el-dialog title="会员卡信息" :visible.sync="carddialogVisible" width="100%" top="0px" :lock-scroll="false">
        <el-table border :data="cardList" size="mini" style="text-align: center" highlight-current-row>
            <el-table-column align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="setCardInfo(scope.row)">选择</el-button>
                </template>
            </el-table-column>
            <el-table-column label="合作门店" align="center"prop="hzstorename"></el-table-column>
            <el-table-column label="会员卡号" align="center"prop="cardnumber"></el-table-column>
            <el-table-column label="会员姓名" align="center"prop="membername"></el-table-column>
            <el-table-column label="手机号码" align="center"prop="memberphone"></el-table-column>
            <el-table-column label="储值余额" align="center"prop="balance"></el-table-column>
        </el-table>
    </el-dialog>
</div>
</template>
<script>
    export default {
        data() {
            return {
                cardList:[],
                carddialogVisible:false,
                queryLoadBtton:false,
                dialogVisible:false,
                queryCardOperation:[],
                param:{},
                addCardOperation:{},
                addBuyCourse:[],
                rules:{
                    cardnumber: [
                        {required: true, message: "请输入会员卡号", trigger: 'blur'}
                    ],
                },
                buyCourse:{
                    storeid:"",
                    sysbillid:"",
                    courseid:"",
                    projectid:"",
                    projectname:"",
                    projectbigtype:"",
                    projecttotaltype1:"",
                    projecttotaltype2:"",
                    coursestdprice:"",
                    coursstdnumber:"",
                    iscooperation:"",
                    cooperationamounttype:"",
                    cooperationamount:"",
                    iscoursediscount:"",
                    iscourseupdateprice:0,
                    discount:"",
                    number:"",
                    amount:0,
                    arrearsamount:"",
                    payid1:"d5668deb1824460dad5429920096705d",
                    payamount1:"",
                    payid2:"39824e23e1384b80a69f9b6dc9c60419",
                    payname2:"",
                    payamount2:"",
                    payid3:"",
                    payname3:"",
                    payamount3:"",
                    staffid1:"",
                    staffperf1:"",
                    stafflv1:"",
                    staffid2:"",
                    staffperf2:"",
                    stafflv2:"",
                    staffid3:"",
                    staffperf3:"",
                    stafflv3:"",
                    remarks:"",
                    enddate:this.$moment().add("years",100),
                    isdy:true,//是否可以抵扣
                    dyamount:0,
                    coursestdminprice:0,
                    courseminnumber:0,
                    beforedisamount:0,//折前金额
                    curcoursestdminprice:0,
                    vouchers:[],//可抵用券的集合
                    curVoucher:{},
                    isexpcourse:0,
                    ishasexp:true,
                    assistid:"",
                    tickettype:1,
                    ticketno:"",
                    orderid:"",
                    svrtype1:2,
                    svrtype2:2,
                    svrtype3:2,
                    hairlv:0,
                },
                cardoperation:{
                    headstaffid:"",
                    hzstoreid:"",
                    isadd:false,
                    storeid:"",
                    sysbillid:"",
                    billtype:3,
                    cardgstoreid:"",
                    cardid:"",
                    cardtypeid:"f24740c985fb473e8a6908c0317f8545",
                    cardtypename:"",
                    cardnumber:"",
                    membername:"",
                    membersource:[],
                    membersource1:"",
                    membersource2:"",
                    sex:"",
                    memberphone:"",
                    birthday:"",
                    cid:"",
                    openamount:0,
                    rechangeamount:0,
                    storearrears:0,
                    coursearrears:0,
                    amount:0,
                    beforebalance:0,
                    oldgstoreid:"",
                    oldcardid:"",
                    oldcardtypeid:"",
                    oldcardnumber:"",
                    oldmembername:"",
                    oldsex:null,
                    oldbalance:0,
                    paystatus:1,
                    accountdate:this.$moment().format('YYYY-MM-DD'),
                    createdate:"",
                    createtor:"",
                    createtorname:"",
                    password:"",
                    remarks:"",
                    accountid:"",
                    shareamount:0,
                    memberid:"",
                    tickettype:1,
                    ticketno:"",
                    orderid:"",
                },
                staffInfos:[],
                storeid:localStorage.getItem("storeid"),
                projectInfos:[],
                projectMap:[],
                ismore:true,
                curpage:1,
                staffMap:[],
            }
        },
        created() {
            this.getStaffByJob();
            this.getProjectInfoByCourse();
            this.getCardOperationByParam();
            let cardnumber=this.$route.query.cardnumber;
            if(cardnumber){
                this.openBuyCardCourse();
                this.addCardOperation.cardnumber=cardnumber;
                this.getCardInfoByCourse();
            }
        },
        methods:{
            handleClose(a){
            
                this.dialogVisible = false
                this.$router.push({
                    path:"/headstaff"
                });
            },
            setCardInfo(obj){
                this.addCardOperation.cardnumber = obj.cardnumber;
                this.addCardOperation.cardtypeid = obj.cardtypeid;
                this.addCardOperation.openamount = obj.openamount;
                this.addCardOperation.rechangeamount = obj.rechargeamount;
                            //this.cardoperation.amount = response.object.rechargeamount;
                this.addCardOperation.cardid = obj.cardid;
                this.addCardOperation.cardgstoreid = obj.storeid;
                this.addCardOperation.membername = obj.membername;
                this.addCardOperation.memberphone = obj.memberphone;
                this.addCardOperation.cardtypename = obj.cardtypename;
                this.addCardOperation.sex = obj.sex;
                this.addCardOperation.memberid = obj.memberid;
                this.addCardOperation.birthday = obj.birthday;
                this.addCardOperation.beforebalance=obj.balance;
                this.addCardOperation.hzstoreid=obj.hzstoreid;
                this.carddialogVisible=false;
            },
            getCardInfoByCourse(){
                if(!this.addCardOperation.cardnumber){
                            this.addCardOperation.cardnumber = "";
                            this.addCardOperation.cardtypeid = "";
                            this.addCardOperation.openamount = "";
                            this.addCardOperation.rechangeamount = "";
                            //this.cardoperation.amount = response.object.rechargeamount;
                            this.addCardOperation.cardid = "";
                            this.addCardOperation.cardgstoreid = "";
                            this.addCardOperation.membername = "";
                            this.addCardOperation.memberphone = "";
                            this.addCardOperation.cardtypename = "";
                            this.addCardOperation.sex = 0;
                            this.addCardOperation.memberid = "";
                            this.addCardOperation.birthday = "";
                            this.addCardOperation.beforebalance=0;
                            this.addCardOperation.hzstoreid="";
                    return;
                }
                this.$post("cardinfo/getCardInfoByCourse",{storeid:this.storeid,param:this.addCardOperation.cardnumber}).then(res=>{
                    if(res.sucess){
                        if(res.object!=null && res.object.length==1) {
                            let obj=res.object[0];
                            this.addCardOperation.cardnumber = obj.cardnumber;
                            this.addCardOperation.cardtypeid = obj.cardtypeid;
                            this.addCardOperation.openamount = obj.openamount;
                            this.addCardOperation.rechangeamount = obj.rechargeamount;
                            //this.cardoperation.amount = response.object.rechargeamount;
                            this.addCardOperation.cardid = obj.cardid;
                            this.addCardOperation.cardgstoreid = obj.storeid;
                            this.addCardOperation.membername = obj.membername;
                            this.addCardOperation.memberphone = obj.memberphone;
                            this.addCardOperation.cardtypename = obj.cardtypename;
                            this.addCardOperation.sex = obj.sex;
                            this.addCardOperation.memberid = obj.memberid;
                            this.addCardOperation.birthday = obj.birthday;
                            this.addCardOperation.beforebalance=obj.balance;
                            this.addCardOperation.hzstoreid=obj.hzstoreid;
                        }
                        else if(res.object!=null && res.object.length>1){
                            this.cardList=res.object;
                            this.carddialogVisible=true;
                        }
                        else{
                            this.$message.error("会员卡不存在");
                            this.addCardOperation.cardnumber = "";
                            this.addCardOperation.cardtypeid = "";
                            this.addCardOperation.openamount = "";
                            this.addCardOperation.rechangeamount = "";
                            //this.cardoperation.amount = response.object.rechargeamount;
                            this.addCardOperation.cardid = "";
                            this.addCardOperation.cardgstoreid = "";
                            this.addCardOperation.membername = "";
                            this.addCardOperation.memberphone = "";
                            this.addCardOperation.cardtypename = "";
                            this.addCardOperation.sex = 0;
                            this.addCardOperation.memberid = "";
                            this.addCardOperation.birthday = "";
                            this.addCardOperation.beforebalance=0;
                            this.addCardOperation.hzstoreid="";
                        }
                    }
                    else{
                            this.addCardOperation.cardnumber = "";
                            this.addCardOperation.cardtypeid = "";
                            this.addCardOperation.openamount = "";
                            this.addCardOperation.rechangeamount = "";
                            //this.cardoperation.amount = response.object.rechargeamount;
                            this.addCardOperation.cardid = "";
                            this.addCardOperation.cardgstoreid = "";
                            this.addCardOperation.membername = "";
                            this.addCardOperation.memberphone = "";
                            this.addCardOperation.cardtypename = "";
                            this.addCardOperation.sex = 0;
                            this.addCardOperation.memberid = "";
                            this.addCardOperation.birthday = "";
                            this.addCardOperation.beforebalance=0;
                            this.addCardOperation.hzstoreid="";
                            this.$message.error(res.message);
                    }
                });
            },
            amountChange(item) {
                //console.log(scope.row.beforedisamount);
                if(isNaN(item.amount)) {
                    this.$nextTick(function () {
                        item.amount = 0;
                    });
                }
                if (this.$parseInt(item.curcoursestdminprice) > 0) {
                    if (this.$parseInt(item.amount) < this.$parseInt(item.curcoursestdminprice)) {
                        this.$nextTick(function () {
                            item.beforedisamount = this.$parseInt(item.curcoursestdminprice);
                            item.amount = this.$parseInt(item.beforedisamount);
                            item.payamount2 = this.$parseInt(item.amount);
                            item.payamount1 = 0;
                            item.payamount3 = 0;
                            item.dyamount = 0;
                            item.arrearsamount = 0;
                        });
                        this.$message.error(item.projectname + ",最小销售金额为" + this.$parseInt(item.curcoursestdminprice), '提示');
                    }
                    else {
                        this.$nextTick(function () {
                            item.amount = this.$parseInt(item.amount);
                            item.payamount2 = this.$parseInt(item.amount);
                            item.payamount1 = 0;
                            item.payamount3 = 0;
                            item.dyamount = 0;
                            item.arrearsamount = 0;
                        });
                    }
                }
                else{
                    this.$nextTick(function () {
                        item.amount = this.$parseInt(item.amount);
                        item.payamount2 = this.$parseInt(item.amount);
                        item.payamount1 = 0;
                        item.payamount3 = 0;
                        item.dyamount = 0;
                        item.arrearsamount = 0;
                    });
                }
                //获取标准价格
                //item.coursstdnumber = projectObj.coursenumber * 1;
                let maxPrice=parseInt(this.$parseInt(item.coursestdprice)/this.$parseInt(item.coursstdnumber));
                let maxAmount=this.$parseInt(maxPrice)*this.$parseInt(item.number);
                if(this.$parseInt(item.amount)>maxAmount){
                    this.$nextTick(function () {
                        item.beforedisamount=maxAmount;
                        item.amount = this.$parseInt(maxAmount);
                        item.payamount2 = this.$parseInt(maxAmount);
                        item.payamount1 = 0;
                        item.payamount3 = 0;
                        item.dyamount = 0;
                        item.arrearsamount = 0;
                    });
                    this.$message.error(item.projectname + ",最大销售金额为" + this.$parseInt(maxAmount), '提示');
                }
                //this.calCanVoucher();
            },
            numberChange(item) {
                if(isNaN(item.number)) {
                    this.$nextTick(function () {
                        item.number = 0;
                    });
                }
                if(this.$parseInt(item.courseminnumber)>0) {
                    //有最小次数现在，如果是小于1的话我们认为是不限制的
                    if (this.$parseInt(item.number) < this.$parseInt(item.courseminnumber)) {
                        this.$nextTick(function () {
                            item.number = this.$parseInt(item.courseminnumber);
                            item.beforedisamount = Math.floor(this.$parseInt(item.coursestdminprice) / this.$parseInt(item.coursstdnumber) * this.$parseInt(item.courseminnumber));
                            item.amount = this.$parseInt(item.beforedisamount);
                            item.curcoursestdminprice = this.$parseInt(item.coursestdminprice) * this.$parseInt(item.courseminnumber);
                            item.payamount2 = this.$parseInt(item.amount);
                            item.payamount1 = 0;
                            item.payamount3 = 0;
                            item.arrearsamount = 0;
                            item.dyamount = 0;
                            //this.calCanVoucher();
                        });
                        this.$message.error(item.projectname + "最低次数" + item.courseminnumber + "次", '提示');
                    }
                    else {
                        this.$nextTick(function () {
                            let amount = Math.floor(this.$parseInt(item.coursestdprice) / this.$parseInt(item.coursstdnumber) * this.$parseInt(item.number));
                            if (isNaN(amount)) {
                                amount = 0;
                            }
                            item.amount = amount;
                            item.beforedisamount = this.$parseInt(item.amount);
                            item.curcoursestdminprice = this.$parseInt(item.coursestdminprice) * this.$parseInt(item.number);
                            item.payamount2 = this.$parseInt(item.amount);
                            item.payamount1 = 0;
                            item.payamount3 = 0;
                            item.arrearsamount = 0;
                            item.dyamount = 0;
                            //this.calCanVoucher();
                        });
                    }
                }
            },
            saveBuyCourse(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        let saveCardCourse=[];
                        for(let val of this.addBuyCourse){
                            if(val.projectid){
                                val.discount=1;
                                saveCardCourse.push(val);
                            }
                        }
                        if(this.saveCardCourse!=null && this.saveCardCourse.length>0){
                            this.$message.error("请输入购买疗程明细");
                            return;
                        }
                        let isstaff=true;
                        for(let val of saveCardCourse){
                            if(!val.staffid1){
                                isstaff=false;
                                break;
                            }
                        }
                        if(isstaff==false){
                            this.$message.error("请输入销售人员");
                            return;
                        }
                        let cardOperationVo=new Object();
                        this.addCardOperation.storeid=localStorage.getItem("storeid");
                        this.addCardOperation.createtor = localStorage.getItem("staffid");
                        this.addCardOperation.createtorname = localStorage.getItem("staffname");
                        cardOperationVo.cardOperation=this.addCardOperation;
                        cardOperationVo.buyCourses=saveCardCourse;
                        this.$postw("cardinfo/saveBuyCourse",cardOperationVo).then(res=>{
                            if(res.sucess){
                                this.$message({message: '购买成功', type: 'success'});
                                this.dialogVisible=false;
                                this.$router.push({
                                    path:"/headstaff"
                                });
                                //this.changeQuery();
                            }
                            else{
                                this.$message.error(res.message);
                            }
                        });
                    }
                });
            },
            staffchange(item){
                let staff=this.staffMap[item.staffid1];
                item.staffnumber1=staff.staffnumber;
                item.staffname1=staff.staffname;
                item.stafflv1=1;
            },
            changeQuery(){
                this.queryCardOperation=[];
                this.ismore=true;
                this.curpage=1;
                this.getCardOperationByParam();
            },
            getCardOperationByParam(){
                if(this.ismore==false){
                    return;
                }
                this.$post("cardinfo/getCardOperationByParamVo",{storeid:this.storeid,sysbillid:"",cardnumber:this.param.cardnumber,
                accountdate:this.param.accountdate,billtype:3,isback:0,curpage:this.curpage,pagesize:20}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.queryCardOperation.push(val);
                            }
                        }
                        else{
                            this.ismore=false;
                        }
                        console.log(this.queryCardOperation);
                        this.curpage++;
                    }
                    else{
                        this.ismore=false;
                        this.$message.error(res.message);
                    }
                });
            },
            changeProject(item){
                let projectinfo=this.projectMap[item.projectid];
                item.projectname = projectinfo.projectname;
                item.projectbigtype = projectinfo.projectbigtype;
                item.projecttotaltype1 = projectinfo.projecttotaltype1;
                item.projecttotaltype2 = projectinfo.projecttotaltype2;
                item.iscooperation = projectinfo.iscooperation;
                item.cooperationamounttype = projectinfo.cooperationamounttype;
                item.cooperationamount = projectinfo.cooperationamount * 1;
                item.coursstdnumber = projectinfo.coursenumber * 1;
                item.coursestdprice = projectinfo.courseprice * 1;
                item.number = projectinfo.coursenumber * 1;
                    //item.amount = projectObj.courseprice*1;
                item.discount = this.discount * 1;
                item.amount = projectinfo.courseprice * 1 ;
                item.iscoursediscount = projectinfo.iscoursediscount;
                item.iscourseupdateprice = projectinfo.iscourseupdateprice * 1;
                item.payamount2 = projectinfo.courseprice * 1 ;
                item.coursestdminprice = projectinfo.coursestdminprice;
                item.courseminnumber = projectinfo.courseminnumber;
                item.beforedisamount = projectinfo.courseprice;
                item.staffid1=localStorage.getItem("staffid");
                item.curcoursestdminprice = this.$parseInt(projectinfo.coursestdminprice) * this.$parseInt(projectinfo.coursenumber);
                item.payamount1 = 0;
                item.payamount3 = 0;

                let isadd=true;
                for(let val of this.addBuyCourse){
                    if(!val.projectid){
                        isadd=false;
                        break;
                    }
                }
                if(isadd){
                    this.addBuyCourse.push(this.$copy(this.buyCourse));
                }
            },
            openBuyCardCourse(){
                this.dialogVisible=true;
                this.addCardOperation=this.$copy(this.cardoperation);
                this.addBuyCourse=[];
                this.addBuyCourse.push(this.$copy(this.buyCourse));
            },
            getProjectInfoByCourse(){
                this.$post("project/getProjectInfoByCourse",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.projectInfos=res.object;
                        
                        if(res.object!=null && res.object.length>0){
                            for(let val of this.projectInfos){
                                this.projectMap[val.projectid]=val;
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
            },
            getStaffByJob() {
                this.$post("inteboStaff/getStaffByInteboHasBill",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.staffInfos=res.object;
                        if(res.object!=null && res.object.length>0){
                            for(let val of this.staffInfos){
                                this.staffMap[val.staffid]=val;
                            }
                        }
                        
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .myform .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom:0px;
    }
    .el-dialog__body{
        padding:0px 20px;
    }

    .myform .el-form-item{
        margin-bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/intebo/buycardcourse.vue